import React from 'react';

/**
 * Clean Flat Storefront Icon with Location Pin
 * Matching Image 4: Flat design, teal awning, gold/teal alternating scallops,
 * slate-gray walls, striped window, white door, red location pin — no outlines.
 */
export const StorefrontIcon = ({ size = 24, ...props }) => (
    <svg
        viewBox="0 0 100 100"
        width={size}
        height={size}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* ─── Main Wall ──────────────────────────────── */}
        <rect x="14" y="48" width="72" height="35" rx="2" fill="#607D8B" />

        {/* ─── Window (Left) ──────────────────────────── */}
        <rect x="18" y="53" width="38" height="20" rx="1.5" fill="#ECEFF1" />
        {/* Diagonal stripes on window */}
        <line x1="18" y1="68" x2="30" y2="53" stroke="#B0BEC5" strokeWidth="3" strokeLinecap="round" />
        <line x1="26" y1="73" x2="44" y2="53" stroke="#B0BEC5" strokeWidth="3" strokeLinecap="round" />
        <line x1="38" y1="73" x2="56" y2="53" stroke="#B0BEC5" strokeWidth="3" strokeLinecap="round" />
        {/* Clip stripes to the window rect by masking excess with wall color */}
        <rect x="56" y="53" width="1" height="20" fill="#607D8B" />
        <rect x="18" y="73" width="38" height="1" fill="#607D8B" />

        {/* ─── Door (Right) ───────────────────────────── */}
        <rect x="62" y="48" width="18" height="35" rx="1.5" fill="#ECEFF1" />
        {/* Diagonal stripe on door */}
        <line x1="63" y1="78" x2="76" y2="53" stroke="#B0BEC5" strokeWidth="3" strokeLinecap="round" />

        {/* ─── Awning Roof (Teal) ─────────────────────── */}
        <path d="M 20 30 L 80 30 L 86 48 L 14 48 Z" fill="#26C6A2" />

        {/* ─── Scallops (alternating teal / gold) ─────── */}
        {/* Scallop 1 — Teal */}
        <path d="M 14 48 Q 19.5 56 25 48 Z" fill="#26C6A2" />
        {/* Scallop 2 — Gold */}
        <path d="M 25 48 Q 30.5 56 36 48 Z" fill="#FFC857" />
        {/* Scallop 3 — Teal */}
        <path d="M 36 48 Q 41.5 56 47 48 Z" fill="#26C6A2" />
        {/* Scallop 4 — Gold */}
        <path d="M 47 48 Q 52.5 56 58 48 Z" fill="#FFC857" />
        {/* Scallop 5 — Teal */}
        <path d="M 58 48 Q 63.5 56 69 48 Z" fill="#26C6A2" />
        {/* Scallop 6 — Gold */}
        <path d="M 69 48 Q 74.5 56 80 48 Z" fill="#FFC857" />
        {/* Scallop 7 — Teal */}
        <path d="M 80 48 Q 83 54 86 48 Z" fill="#26C6A2" />

        {/* ─── Red Map / Location Pin ──────────────────── */}
        {/* Pin body */}
        <path
            d="M 50 35 C 43 22 43 16 50 10 C 57 4 64 8 64 16 C 64 22 57 30 50 35 Z"
            fill="#F44336"
        />
        {/* Pin inner white circle */}
        <circle cx="50" cy="17" r="4.5" fill="#FFFFFF" />
    </svg>
);

export default StorefrontIcon;
